// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budget-ask-info-component{margin-top:20px !important}.budget-ask-info-component .content .breadcums{color:#1f2933;font-weight:bolder}.budget-ask-info-component .content .form-group:first-of-type{margin-top:25px}.budget-ask-info-component .content .form-group label{color:#51606d}\n", ""]);
// Exports
module.exports = exports;
